


























import { Mixins, Component, Prop, Watch } from "vue-property-decorator";

// Component
import Treeselect from "@riophae/vue-treeselect";

// Treeselect Styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Types
import { IPromotionForm } from "@/models/promotions";
import { IBillingCycle } from "@/models/constants";

@Component({
  components: {
    Treeselect,
    "multi-value-select": () =>
      import("@/components/app/global/fields/multiValueSelect.vue")
  }
})
export default class BillingTermsField extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public value!: IPromotionForm["billing_cycles"];

  @Prop({ required: true })
  public isDisabled!: boolean;

  @Prop({ required: true })
  public billingCycles!: IBillingCycle[];

  @Prop({ default: true })
  public multiple!: boolean;

  public useAllBillingCycles = true;
  public treeSelectBillingTerms: { value: number; label: string }[] = [];

  public created() {
    this.useAllBillingCycles = this.formBillingCycles.length === 0;
    this.treeSelectBillingTerms = this.$_.map(
      this.billingCycles,
      (billingTerm: IBillingCycle) => {
        return {
          value: billingTerm.months,
          label: billingTerm.name
        };
      }
    );

    this.$_.forEach(
      this.$_.filter(
        this.formBillingCycles,
        formBillingCycle =>
          !this.$_.find(this.treeSelectBillingTerms, [
            "value",
            formBillingCycle
          ])
      ),
      missingTerm => {
        this.treeSelectBillingTerms.push({
          value: missingTerm,
          label: this.$t("_.every_months", { months: missingTerm }).toString()
        });
      }
    );
  }

  public get usedBillingTerms() {
    return this.$_.map(
      this.treeSelectBillingTerms,
      (billingTerm: { value: number; label: string }) => billingTerm.value
    );
  }

  // Data
  public get formBillingCycles() {
    return this.value || [];
  }

  public set formBillingCycles(value) {
    this.$emit("input", value);
  }

  public addCustom() {
    this.$store.dispatch("ui/open/windowModal", {
      config: {
        width: 480,
        component: () =>
          import(
            "@/components/app/global/fields/addCustomBillingTermModal.vue"
          ),
        props: {
          usedBillingTerms: this.usedBillingTerms
        },
        events: {
          success: (result: number) => {
            this.treeSelectBillingTerms.push({
              value: result,
              label: this.$t("_.every_months", { months: result }).toString()
            });

            this.$set(
              this,
              "formBillingCycles",
              this.$_.concat(this.formBillingCycles, [result])
            );
          }
        }
      }
    });
  }

  @Watch("useAllBillingCycles")
  public onAllPriceListsChange() {
    if (!this.useAllBillingCycles) return;
    this.$set(this, "formBillingCycles", []);
  }
}
